import React, { useState } from 'react';
import ProjectViewPoup from './ProjectViewPoup';

const ProjectCard = ({ project }) => {

    const { title, video, photo, projectUrl, descriptionId } = project;


    const [imageError, setImageError] = useState(false);

    const handleImageError = () => {
        setImageError(true);
    };

    return (
        <div className='group border rounded-lg p-3 bg-white shadow-sm relative'>
            <div className="relative group h-48 overflow-hidden">
                <img className='h-auto w-full rounded' src={photo} alt={"Munir Uddin Mahbub ||" + title} />
                {/* <Link to={`/project/${descriptionId}`} className=''> */}
                <ProjectViewPoup descriptionId={descriptionId} />
                {/* </Link> */}
            </div>
            <div className="grid grid-cols-8 py-2 content-center">
                <div className="col-span-1 grid content-center">
                    {imageError ? (
                        <img className='rounded-full h-8 w-8' src={(projectUrl === 'null' ? projectUrl : projectUrl) + '/fav.png'} alt="" />

                    ) : (
                        <img onError={handleImageError} className='rounded-full h-8 w-8' src={(projectUrl === 'null' ? projectUrl : projectUrl) + '/favicon.ico'} alt="" />
                    )}
                </div>
                <div className="col-span-7 grid content-center">
                    <h3 className="text-base text-gray-700 font-semibold font-inter">{title}</h3>
                    <p className="text-sm text-gray-600 font-inter">{projectUrl === 'nan' ? projectUrl : projectUrl}</p>
                </div>
            </div>
            {/* <div className="overflow-x-hidden container-snap h-20 py-2">
                {skills.map((item, i) => (
                    <button key={i} className='px-3 py-1 mx-1 mb-2 truncate border rounded-full text-sm font-inter bg-gray-50 text-primary'>{item}</button>
                ))}
            </div> */}
            {/* <div className="p-2">
                <p className='text-sm font-inter text-gray-500'>
                    {someText}
                </p>
            </div> */}
            {/* <div className="absolute top-14 -right-2 opacity-100 group-hover:opacity-100 sm:opacity-0 transition duration-500 ease-in-out">
                <div className=''>
                    {github === 'private' ?
                        <PopupForPrivate github={github} />
                        :
                        <a className='' title="GitHub" href={github} target="_blank" rel="noopener noreferrer">
                            <BsGithub className="hover:text-primary  border-r text-4xl bg-white p-1 rounded-full" />
                        </a>
                    }


                    <br />
                    <a className='text-xl' title="Preview" href={liveLink === 'nan' ? liveLink2 : liveLink} target="_blank" rel="noopener noreferrer">
                        <HiOutlineExternalLink className="hover:text-primary border-r text-4xl bg-white p-1 rounded-full" />
                    </a>
                </div>
            </div> */}
        </div>
    );
};

export default ProjectCard;